import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { CiEdit } from "react-icons/ci";
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import SocialLinksModal from './SocialLinksModal';

const SocialLinks = () => {
    const childRef = useRef();
    const [socialLinks, setSocialLinks] = useState([]);
    const [loadLinks, setLinkLoading] = useState(false);

    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/getSocialLinks').then((res) => {
            if (res.data && res.data.data) {
                setSocialLinks(res.data.data);
            }
        }).catch((error) => {
            console.log(error);
            toast.error(error.response?.data?.message || "Error fetching Social Links");
        });
    }, [loadLinks]);

    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                            <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                                <div className="dataTables_wrapper no-footer">
                                    <table className="table-responsive-lg table display dataTablesCard student-tab dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }}>
                                        <thead style={{ backgroundColor: "#cccccc" }}>
                                            <tr className='text-center text-dark border border-left'>
                                                <th className='custom-table-header p-2 text-start'>PLATFORM</th>
                                                <th className='text-start custom-table-header p-2'>URL</th>
                                                <th className='p-2 custom-table-header'>ACTIONS</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {socialLinks.length > 0 ? socialLinks.map((item, ind) => (
                                                <tr key={ind} className={`${ind % 2 === 1 ? 'custom row-height' : 'row-height'}`}>
                                                    <td className='text-start p-1 active-col-width' style={{ border: "1px solid #cccccc", width: "150px" }}>
                                                        <h6 className="sn-font-weight mb-0">{item.Platform}</h6>
                                                    </td>
                                                    <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                                        <a href={item.Url} target="_blank" rel="noopener noreferrer" style={{ fontSize: '13px', color: '#01A3FF' }}>{item.Url}</a>
                                                    </td>
                                                    <td className='text-center p-1' style={{ border: "1px solid #cccccc", width: "100px" }}>
                                                        <CiEdit cursor='pointer' title='Edit Social Link' size={20} className='text-primary mx-2' onClick={() => childRef.current.openModal(item)} />
                                                    </td>
                                                </tr>
                                            )) :
                                                <tr>
                                                    <td colSpan="3" className="text-center">
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                            No Social Links Found
                                                        </div>
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SocialLinksModal ref={childRef} loadLinks={loadLinks} setLinkLoading={setLinkLoading} />
        </>
    );
}

export default SocialLinks;
